import { IDatabaseLineItem } from "../pages/CreatorTools/LineItemDBCreationTool/types";
import { ComplementsRuleInputs, Rule } from "@rebuild/shared";
import { validateComplementsAndRecommendations } from "./validationFunctions/validateComplementsAndRecommendations";
import { validateLineItemTransformation } from "./validationFunctions/validateLineItemTransformation";
import { validateMultiParentTransformations } from "./validationFunctions/validateMultiParentTransformations";
import {
  ComplementsRuleInputPaths,
  LineItemTransformationRuleInputPaths,
  MultiParentTransformationsRuleInputPaths,
  Paths,
  ValidationErrorEntry,
} from "./validationFunctions/types";

/**
 * Generate and return a key/value map where the key is a path to a field in the rule obejct and the value is an error message.
 * If this key/value map is empty, then that means that all validation checks were passed.
 */
export function validateRuleInputs(
  rule: Rule,
  dbLineItems: IDatabaseLineItem[],
): Map<ComplementsRuleInputPaths | MultiParentTransformationsRuleInputPaths | LineItemTransformationRuleInputPaths, ValidationErrorEntry> | undefined {
  if (rule.ruleInputs === undefined) {
    return undefined;
  }

  if (rule.templateId === "complements_and_recommendations") {
    return validateComplementsAndRecommendations(rule, dbLineItems);
  }

  if (rule.templateId === "multi_parent_transformations") {
    return validateMultiParentTransformations(rule, dbLineItems);
  }

  if (rule.templateId === "line_item_transformation") {
    return validateLineItemTransformation(rule, dbLineItems);
  }
}
